import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'
import moment from 'moment'

export default {
  generateReport (VueApp, done) {
    let self = this
    let sectors = VueApp.$store.state.coverage.report.sectors
    // console.log('GENERATE REPORT MODULE', sectors)

    let masterList = []
    XlsxPopulate.fromBlankAsync().then(workbook => {
      for (let i = 0; i < sectors.length; i++) {
        let sector = sectors[i]
        let sheetName = sector.name.replace(/\//g, '-').substring(0, 31)
        workbook.addSheet(sheetName)
        masterList.push(self.renderDaysAndTime(workbook, sheetName, sector))
      }

      workbook.deleteSheet('Sheet1')
      self.renderMasterList(workbook, masterList)

      workbook.outputAsync().then(function (blob) {
        let start = moment(VueApp.$store.state.coverage.filters.startDate)
        let end = moment(VueApp.$store.state.coverage.filters.endDate)
        let filename = 'CoverageReport_' + start.format('MMDDYYYY') + '_' + end.format('MMDDYYYY')
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename)
        } else {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
        done()
      })
    })
  },

  renderMasterList (workbook, masterList) {
    let font = 'Calibri'
    let sheets = workbook.sheets()
    let sheetName = 'Master List'
    workbook.addSheet(sheetName, sheets[0])

    // render dates
    let cellNumber = 2
    let totals = []
    let dates = masterList[0].days
    for (let i = 0; i < dates.length; i++) {
      let day = dates[i]
      workbook.sheet(sheetName)
        .row(1).cell(cellNumber)
        .style({
          fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: '59C198' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        })
        .value(day.date.format('MM/DD/YYYY'))
      totals.push({
        openBusiness: 0,
        availableDrivers: 0
      })
      cellNumber++
    }

    // render list
    let rowNumber = 2
    let openFill = 'CEDEEF'
    let availableFill = 'CEDEEF'
    workbook.sheet(sheetName).column('A').width(40)
    for (let i = 0; i < masterList.length; i++) {
      let sector = masterList[i]

      workbook.sheet(sheetName).cell('A' + rowNumber).style({
        fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'center',
        fill: { color: '4A85C9' },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value(sector.name)
      workbook.sheet(sheetName).cell('A' + (rowNumber + 1)).style({
        fontColor: '333333',fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'right',
        fill: { color: openFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value('Open Business')
      workbook.sheet(sheetName).cell('A' + (rowNumber + 2)).style({
        fontColor: '333333',fontSize: 11, fontFamily: font, bold: true,
        verticalAlignment: 'center', horizontalAlignment: 'right',
        fill: { color: availableFill },
        border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
      }).value('Available Drivers')

      let days = sector.days
      cellNumber = 2
      for (let j = 0; j < days.length; j++) {
        let day = days[j]

        workbook.sheet(sheetName)
          .row(rowNumber).cell(cellNumber)
          .style({
            fill: { color: '4A85C9' },
            border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
          })
          .value('')
        workbook.sheet(sheetName)
          .row(rowNumber + 1).cell(cellNumber)
          .style({
            fontColor: '333333',fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'center',
            fill: { color: openFill },
            border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
          })
          .value(day.openBusiness)
        workbook.sheet(sheetName)
          .row(rowNumber + 2).cell(cellNumber)
          .style({
            fontColor: '333333',fontSize: 11, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'center',
            fill: { color: availableFill },
            border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
          })
          .value(day.availableDrivers)

        totals[j].openBusiness += day.openBusiness
        totals[j].availableDrivers += day.availableDrivers
        cellNumber++
      }

      rowNumber = rowNumber + 3
    }

    // render totals
    let totalOpenRow = rowNumber + 1
    let totalAvailableRow = rowNumber + 2
    workbook.sheet(sheetName).cell('A' + totalOpenRow).style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Total Open Business')
    workbook.sheet(sheetName).cell('A' + totalAvailableRow).style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Total Available Drivers')

    let totalOpenFill = 'F9CFD9'
    let totalAvailableFill = 'D6F7E2'
    cellNumber = 2
    for (let i = 0; i < totals.length; i++) {
      let total = totals[i]
      workbook.sheet(sheetName)
        .row(totalOpenRow).cell(cellNumber)
        .style({
          fontColor: '333333',fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: totalOpenFill },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        })
        .value(total.openBusiness)
      workbook.sheet(sheetName)
        .row(totalAvailableRow).cell(cellNumber)
        .style({
          fontColor: '333333',fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'center',
          fill: { color: totalAvailableFill },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        })
        .value(total.availableDrivers)
      cellNumber++
    }
  },

  renderDaysAndTime (workbook, sheetName, sector) {
    let sectorData = sector.data
    let font = 'Calibri'

    let master = {
      name: sector.name,
      days: []
    }
    // render dates
    let cellNumber = 2
    let homeDrivers = {}
    for (let prop in sectorData) {
      if (!sectorData.hasOwnProperty(prop)) {
        continue
      }

      let days = sectorData[prop].days
      for (let i = 0; i < days.length; i++) {
        let day = days[i]
        if (day === null) {
          continue
        }
        let dayStart = day.date.unix()
        let dayEnd = moment(day.date.format('MM/DD/YYYY') + ' 11:59:59PM', 'MM/DD/YYYY hh:mm:ssA').unix()
        workbook.sheet(sheetName)
          .row(1).cell(cellNumber)
          .style({
            fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
            verticalAlignment: 'center', horizontalAlignment: 'center',
            fill: { color: '59C198' },
            border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
          })
          .value(day.date.format('MM/DD/YYYY'))

        workbook.sheet(sheetName).column(cellNumber).width(40)

        // open rsvp
        let openBusiness = 0
        for (let j = 0; j < day.availableRsvp.length; j++) {
          let rsvp = day.availableRsvp[j]
          let pickupHour = parseInt(rsvp.pickupTime.format('HH')) + 2
          if (rsvp.packageID !== null) {
            pickupHour = parseInt(rsvp.firstPickup.format('HH')) + 2
          }

          let textValue = 'Open ' + (rsvp.packageID !== null ? ('Package ' + rsvp.packageID) : ('Reservation ' + rsvp.rsvpId)) + ' at ' + rsvp.pickupTime.format('hh:mmA')
          workbook.sheet(sheetName)
            .row(pickupHour).cell(cellNumber)
            .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left'
            })
            .value(textValue)
          openBusiness++
        }
        workbook.sheet(sheetName)
          .row(27).cell(cellNumber)
          .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left',
              fill: { color: 'EECDCD' },
              border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
            })
          .value(openBusiness.toString())
        // open rsvp end

        // open availability
        let gapText = null
        for (let j = 0; j < day.shiftGaps.length; j++) {
          let gap = day.shiftGaps[j]
          let gapStr = gap.start.format('hh:mmA') + ' - ' + gap.end.format('hh:mmA')
          if (gapText !== null) {
            gapText = gapText + '\n'
          } else {
            gapText = ''
          }
          gapText = gapText + gapStr
        }
        workbook.sheet(sheetName)
          .row(28).cell(cellNumber)
          .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left',
              fill: { color: 'EECDCD' },
              border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
            })
          .value(gapText)
        // open availability end

        // covered rsvp
        let coveredBusiness = 0
        for (let j = 0; j < day.assignedRsvp.length; j++) {
          let rsvp = day.assignedRsvp[j]
          let pickupHour = parseInt(rsvp.pickupTime.format('HH')) + 2
          if (rsvp.packageID !== null) {
            pickupHour = parseInt(rsvp.firstPickup.format('HH')) + 2
          }

          let existingValue = workbook.sheet(sheetName)
            .row(pickupHour).cell(cellNumber).value()

          let textValue = 'Assigned ' + (rsvp.packageID !== null ? ('Package ' + rsvp.packageID) : ('Reservation ' + rsvp.rsvpId)) + ' at ' + rsvp.pickupTime.format('hh:mmA')
          
          if (existingValue !== null && typeof existingValue !== 'undefined') {
            textValue = existingValue + '\n' + textValue
          }
          workbook.sheet(sheetName)
            .row(pickupHour).cell(cellNumber)
            .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left'
            })
            .value(textValue)
          coveredBusiness++
        }
        workbook.sheet(sheetName)
          .row(29).cell(cellNumber)
          .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left',
              fill: { color: 'DCE9D5' },
              border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
            })
          .value(coveredBusiness.toString())
        // covered rsvp end

        // available drivers
        let availableDrivers = 0
        for (let j = 0; j < day.workDrivers.length; j++) {
          let driver = day.workDrivers[j]
          let start = driver.shiftStart
          let end = driver.shiftEnd

          let startHour = parseInt(start.format('HH')) + 2
          let endHour = parseInt(end.format('HH')) + 2


          let existingStartValue = workbook.sheet(sheetName)
            .row(startHour).cell(cellNumber).value()
          let startValue = driver.driverId + ' - ' + driver.firstName + ' ' + driver.lastName + ' starts at ' + start.format('hh:mmA')
          if (existingStartValue !== null && typeof existingStartValue !== 'undefined') {
            startValue = existingStartValue + '\n' + startValue
          }
          workbook.sheet(sheetName)
            .row(startHour).cell(cellNumber)
            .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left'
            })
            .value(startValue)

          let existingEndValue = workbook.sheet(sheetName)
            .row(endHour).cell(cellNumber).value()
          let endValue = driver.driverId + ' - ' + driver.firstName + ' ' + driver.lastName + ' ends at ' + end.format('hh:mmA')
          if (existingEndValue !== null && typeof existingEndValue !== 'undefined') {
            endValue = existingEndValue + '\n' + endValue
          }
          workbook.sheet(sheetName)
            .row(endHour).cell(cellNumber)
            .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left'
            })
            .value(endValue)
          // TODO: render drivers on calendar
          availableDrivers++
        }
        workbook.sheet(sheetName)
          .row(30).cell(cellNumber)
          .style({
              fontColor: '333333',fontSize: 11, bold: true,
              verticalAlignment: 'center', horizontalAlignment: 'left',
              fill: { color: 'DCE9D5' },
              border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
            })
          .value(availableDrivers.toString())
        // available drivers end

        // home drivers
        for (let j = 0; j < day.homeDrivers.length; j++) {
          let driver = day.homeDrivers[j]
          homeDrivers[driver.driverId] = {
            name: driver.firstName + ' ' + driver.lastName
          }
        }
        // home drivers end

        master.days.push({
          date: day.date,
          openBusiness: openBusiness,
          availableDrivers: availableDrivers
        })
        cellNumber++
      }
    }

    // render times
    let timeStyle = {
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '4A85C9' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }

    workbook.sheet(sheetName).cell('A2').style(timeStyle).value('12:00AM')
    workbook.sheet(sheetName).cell('A3').style(timeStyle).value('01:00AM')
    workbook.sheet(sheetName).cell('A4').style(timeStyle).value('02:00AM')
    workbook.sheet(sheetName).cell('A5').style(timeStyle).value('03:00AM')
    workbook.sheet(sheetName).cell('A6').style(timeStyle).value('04:00AM')
    workbook.sheet(sheetName).cell('A7').style(timeStyle).value('05:00AM')
    workbook.sheet(sheetName).cell('A8').style(timeStyle).value('06:00AM')
    workbook.sheet(sheetName).cell('A9').style(timeStyle).value('07:00AM')
    workbook.sheet(sheetName).cell('A10').style(timeStyle).value('08:00AM')
    workbook.sheet(sheetName).cell('A11').style(timeStyle).value('09:00AM')
    workbook.sheet(sheetName).cell('A12').style(timeStyle).value('10:00AM')
    workbook.sheet(sheetName).cell('A13').style(timeStyle).value('11:00AM')
    workbook.sheet(sheetName).cell('A14').style(timeStyle).value('12:00PM')
    workbook.sheet(sheetName).cell('A15').style(timeStyle).value('01:00PM')
    workbook.sheet(sheetName).cell('A16').style(timeStyle).value('02:00PM')
    workbook.sheet(sheetName).cell('A17').style(timeStyle).value('03:00PM')
    workbook.sheet(sheetName).cell('A18').style(timeStyle).value('04:00PM')
    workbook.sheet(sheetName).cell('A19').style(timeStyle).value('05:00PM')
    workbook.sheet(sheetName).cell('A20').style(timeStyle).value('06:00PM')
    workbook.sheet(sheetName).cell('A21').style(timeStyle).value('07:00PM')
    workbook.sheet(sheetName).cell('A22').style(timeStyle).value('08:00PM')
    workbook.sheet(sheetName).cell('A23').style(timeStyle).value('09:00PM')
    workbook.sheet(sheetName).cell('A24').style(timeStyle).value('10:00PM')
    workbook.sheet(sheetName).cell('A25').style(timeStyle).value('11:00PM')

    // totals
    workbook.sheet(sheetName).cell('A27').style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Open Business')
    workbook.sheet(sheetName).cell('A28').style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: 'CC042A' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Open Availability')
    workbook.sheet(sheetName).cell('A29').style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Covered Business')
    workbook.sheet(sheetName).cell('A30').style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Available Drivers')

    // home drivers
    workbook.sheet(sheetName).cell('A32').style({
      fontColor: 'FFFFFF',fontSize: 11, fontFamily: font, bold: true,
      verticalAlignment: 'center', horizontalAlignment: 'right',
      fill: { color: '27C664' },
      border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
    }).value('Home-Based Drivers')

    let homeDriversValue = ''
    for (let prop in homeDrivers) {
      if (!homeDrivers.hasOwnProperty(prop)) {
        continue
      }
      let driverText = prop + ' - ' + homeDrivers[prop].name
      homeDriversValue = homeDriversValue + driverText
    }

    if (homeDriversValue === '') {
      homeDriversValue = '0'
    }
    workbook.sheet(sheetName)
      .row(32).cell(2)
      .style({
          fontColor: '333333',fontSize: 11, bold: true,
          verticalAlignment: 'center', horizontalAlignment: 'left',
          fill: { color: 'DCE9D5' },
          border: 'top', borderStyle: 'thin', borderColor: 'E2E3E3'
        })
      .value(homeDriversValue)
    // home drivers end

    // column width
    workbook.sheet(sheetName).column('A').width(20)
    return master
  }
}



// WEBPACK FOOTER //
// ./src/components/Coverage/report-generator.js